var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/lodash/_Symbol.js
// module id = 96
// module chunks = 1